import { render, staticRenderFns } from "./SurgEditErrors.vue?vue&type=template&id=51fc8484&"
import script from "./SurgEditErrors.vue?vue&type=script&lang=js&"
export * from "./SurgEditErrors.vue?vue&type=script&lang=js&"
import style0 from "./SurgEditErrors.vue?vue&type=style&index=0&id=51fc8484&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports